import { TurboModuleRegistry } from 'react-native';
export default TurboModuleRegistry.getEnforcing('RNZohoSalesIQMobilisten');
//# sourceMappingURL=NativeRNZohoSalesIQ.js.map